{
    "nav__new_offer": "New Offer",
    "nav__continue_as_order": "Continue as order",

    "footer_button__next": "Next",
    "footer_button__back": "Back",
    "footer_button__save": "Save Draft",
    "footer_button__finalize": "Finalize",
    "footer_button__cancel": "Cancel",
    "footer_button__view_detail": "View Order Detail",

    "stepper__step_1": "Header",
    "stepper__step_2": "Individual items",
    "stepper__step_3": "Review"
}
